'use client';

import clsx from 'clsx';
import { ArrowRight } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { AppLink } from '@//components/AppLink';
import styles from './Breadcrumb.module.scss';

export interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
  testId: string;
  className?: string;
}

export const Breadcrumb: React.FC<BreadcrumbsProps> = ({ items, testId, className }) => {
  const t = useTranslations('components.breadcrumb');

  return (
    <nav className={clsx(styles.nav, className)} aria-label={t('breadcrumb')} data-testid={testId}>
      <ol className={styles.list}>
        {items.map((item, index) => {
          const isLast = index === items.length - 1;

          return (
            <li key={index} className={styles.item} data-testid={`${testId}-item-${index + 1}`}>
              {item.href && !isLast ? (
                <AppLink
                  href={item.href}
                  className={styles.link}
                  data-testid={`${testId}-item-${index + 1}-link`}
                  prefetch="hover"
                >
                  {item.label}
                </AppLink>
              ) : (
                <span
                  className={styles.label}
                  data-testid={`${testId}-item-${index + 1}-item`}
                  aria-current={isLast ? 'page' : undefined}
                >
                  {item.label}
                </span>
              )}
              {!isLast && <ArrowRight aria-hidden="true" />}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};
